import httpAuth from "@/common/http/http-common";
import { LoginFormDto, RegisterFormDto, ResetPasswordFormDto, UserClaims } from "@/types/user.type";

class AuthService {
  client = httpAuth("auth");

  async loginAsync(form: LoginFormDto): Promise<string> {
    const { data } = await this.client.post("login", form);

    return data;
  }

  async userInfoAsync(): Promise<UserClaims> {
    const { data } = await this.client.get("user-info");

    return data;
  }

  async registerAsync(form: RegisterFormDto): Promise<void> {
    await this.client.post("register", form);
  }

  async resetPasswordAsync(form: ResetPasswordFormDto): Promise<void> {
    await this.client.post("reset/confirm", form);
  }

  async requestPasswordResetAsync(form: ResetPasswordFormDto): Promise<void> {
    await this.client.post("reset", form);
  }

  async resendConfirmationAsnyc(form: LoginFormDto): Promise<void> {
    await this.client.post("confirm/resend", form);
  }
}

export default new AuthService();